import Swal from "sweetalert2"
import faradayApi from "../../api/faradayApi"


export const addEvent = async (formValues, succesMsg, errorMsg, errorNameDup, navigate) => {
    try {
        const { data } = await faradayApi.post('/events', formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            navigate('/events')
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        if (error.response.data.msg.original.code === 'ER_DUP_ENTRY') {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorNameDup,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: error,
                icon: "error",
                iconColor: '#FF7765'
            })
        }
    }
}

export const editEvent = async (formValues, succesMsg, errorMsg, errorNameDup) => {
    try {

        const { data } = await faradayApi.put('/events', formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${succesMsg}`,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }

    } catch (error) {
        console.log(error)
        if (error.response.data.msg.original.code === 'ER_DUP_ENTRY') {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorNameDup,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: error,
                icon: "error",
                iconColor: '#FF7765'
            })
        }
    }
}

export const deleteEvent = async(e, succesMsg, errorMsg, cancelButton, confirmButton, deleteConfirm) => {
    const {value} = await Swal.fire({
        text: `${deleteConfirm} ${e.row.name}`,
        showCancelButton: true,
        confirmButtonColor: '#001B60',
        cancelButtonText: cancelButton,
        confirmButtonText: confirmButton,
        reverseButtons: true
      })
    value && onConfirm(e.row.id, succesMsg, errorMsg, e.row.name)
}

const onConfirm = async (id, succesMsg, errorMsg, name) => {
    try {
        const { data } = await faradayApi.delete('/events', { data: { id } });

        data.data !== 0 && !data.error  ?
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${name} ${succesMsg}`,
                icon: "success",
            })
            :
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
            })  
    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorMsg,
            icon: "error",
        })  
    }
         
}